import { Navigate } from "react-router-dom";
import { useApp } from "@/contexts/AppContext";

export default function ProtectedRoute({ children }) {
  const { user } = useApp();
  if (user === null) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-slate-50">
        <div className="text-sm text-slate-500">Cargando...</div>
      </div>
    );
  }
  if (!user) return <Navigate to="/login" replace />;
  return children;
}
